import { CommonResponse, deleteData, get, post, put } from './common.ts'

/**
 * (01)
 * 수업 목록 조회
 */

// GET /courses
interface GetCoursesRequest {
  categoryType: string
  semesterId: string
}
interface GetCoursesResponse {
  name: string
  courses: {
    id: string
    className: string
    semester: {
      id: string
      name: string
      startDate: number
      endDate: number
      schoolId: string
    }
    subject: {
      id: string
      name: string
      schoolId: string
      majorId: string
    }
    teacher: {
      id: string
      accountId: string
      name: string
      approveStatus: string
      phoneNumber: string
      schoolId: string
    }
    school: {
      id: string
      name: string
      educationLevel: string
    }
    courseTimeTable: {
      id: string
      dayOfWeek: string
      coursePeriod: number
      courseId: string
    }[]
    image: {
      id: string
      imageUrl: string
      backgroundColor: string
      textColor: string
      courseId: string
    }
  }[]
}

export const getCourses = async (
  request: GetCoursesRequest,
): Promise<CommonResponse<GetCoursesResponse>> => {
  return await get(`/courses?categoryType=${request.categoryType}&semesterId=${request.semesterId}`)
}

/**
 * (02)
 * 커버 선택 정보 조회
 */

// GET /courses/cover-info
interface GetCoursesCoverInfoResponse {
  images: {
    basicImage: {
      id: string
      url: string
    }[]
    majorImage: {
      id: string
      url: string
    }[]
  }
  colors: {
    violet: {
      id: string
      backgroundColor: string
      textColor: string
    }[]
    lightBlue: {
      id: string
      backgroundColor: string
      textColor: string
    }[]
    orange: {
      id: string
      backgroundColor: string
      textColor: string
    }[]
  }
}

export const getCoursesCoverInfo = async (): Promise<
  CommonResponse<GetCoursesCoverInfoResponse>
> => {
  return await get('/courses/cover-info')
}

/**
 * (03)
 * 수업 등록
 */

// POST /courses
interface PostCoursesRequest {
  className: string
  semesterId: string
  subjectId: string
  courseTimes: {
    dayOfWeek: string
    period: number
  }[]
  imageId: string
  colorId: string
}

export const postCourses = async (body: PostCoursesRequest): Promise<CommonResponse<null>> => {
  return await post('/courses', body)
}

/**
 * (04)
 * 수업 수정
 */

// PUT /courses/{courseId}
interface PutCoursesRequestParams {
  courseId: string
}
interface PutCoursesRequestBody {
  className: string
  imageId: string
  colorId: string
}

export const putCourses = async (
  request: PutCoursesRequestParams,
  body: PutCoursesRequestBody,
): Promise<CommonResponse<null>> => {
  return await put(`/courses/${request.courseId}`, body)
}

/**
 * (05)
 * 수업 삭제
 */

// DELETE /courses/{courseId}
interface DeleteCoursesRequest {
  courseId: string
}

export const deleteCourses = async (body: DeleteCoursesRequest): Promise<CommonResponse<null>> => {
  return await deleteData(`/courses/${body.courseId}`, body)
}

/**
 * (06)
 * 수업 학생 조회
 */

// GET /courses/{courseId}/students
interface GetCoursesStudentRequest {
  courseId: string
  sortBy: string
  name: string
}
interface GetCoursesStudentResponse {
  id: string
  studentId: string
  admissionYear: number
  grade: number
  classNumber: number
  studentNumber: number
  name: string
  status: string
  schoolId: string
  majorGroup: string
}

export const getCoursesStudent = async (
  request: GetCoursesStudentRequest,
): Promise<CommonResponse<GetCoursesStudentResponse>> => {
  const sortBy = request.sortBy ? `?sortBy=${request.sortBy}` : ''
  const name = request.name ? `&name=${request.name}` : ''
  return await get(`/courses/${request.courseId}/students${sortBy}${name}`)
}

/**
 * (07)
 * 수업 학생 추가
 */

// POST /courses/{courseId}/students
interface PostCoursesStudentRequestParams {
  courseId: string
}
interface PostCoursesStudentRequestBody {}

export const postCoursesStudent = async (
  request: PostCoursesStudentRequestParams,
  body: PostCoursesStudentRequestBody,
): Promise<CommonResponse<null>> => {
  return await post(`/courses/${request.courseId}/students`, body)
}

/**
 * (08)
 * 수업 학생 삭제
 */

//DELETE /courses/{courseId}/students
interface DeleteCoursesStudentRequestParams {
  courseId: string
}
interface DeleteCoursesStudentRequestBody {}
export const deleteCoursesStudent = async (
  request: DeleteCoursesStudentRequestParams,
  body: DeleteCoursesStudentRequestBody,
): Promise<CommonResponse<null>> => {
  return await deleteData(`/courses/${request.courseId}/students`, body)
}

/**
 * (09)
 * 랜덤 커버 정보 조회
 */

// GET /courses/cover-rand
interface GetCoursesCoverRandResponse {
  image: {
    id: string
    url: string
  }
  color: {
    id: string
    backgroundColor: string
    textColor: string
  }
}

export const getCoursesCoverRand = async (): Promise<
  CommonResponse<GetCoursesCoverRandResponse>
> => {
  return await get('/courses/cover-rand')
}
